import { SORT_DIRECTIONS } from 'app/shared/componentsRestyled/common/TooltipedSortLabel';

export const ALL_TAB_VALUE = 'all';

export const TableCellId = {
  EXPAND: 'expand',
  NUMBER: 'number',
  CANONICAL_TITLE: 'canonicalTitle',
  CONDITION: 'condition',
  MESSAGE: 'message',
  CATEGORY: 'conditionCategoryName',
  SUB_COMPANY_MESSAGE: 'subCompanyMessage',
  PRIOR_TO: 'priorToName',
  ADDED_BY: 'createdBy',
  ADDED_DATE: 'createdDate',
  SIGNED_OFF_BY: 'signedOffBy',
  BROKER_STATUS: 'statusLabel',
  SIGNED_OFF_DATE: 'signedOff',
  DELETED_DATE: 'deletedDate',
  STATUS: 'conditionStatus',
  TASKS_COUNT: 'tasksCount',
  SLA: 'slaGroupName',
  ACTIONS: 'actions',
};

export const tableCellWidthMap = {
  [TableCellId.EXPAND]: '48px',
  [TableCellId.NUMBER]: '5%',
  [TableCellId.CANONICAL_TITLE]: '12%',
  [TableCellId.CONDITION]: '32%',
  [TableCellId.MESSAGE]: '13%',
  [TableCellId.CATEGORY]: '14%',
  [TableCellId.SUB_COMPANY_MESSAGE]: '16%',
  [TableCellId.PRIOR_TO]: '12%',
  [TableCellId.ADDED_BY]: '8%',
  [TableCellId.ADDED_DATE]: '8%',
  [TableCellId.SIGNED_OFF_BY]: '8%',
  [TableCellId.BROKER_STATUS]: '12%',
  [TableCellId.SIGNED_OFF_DATE]: '8%',
  [TableCellId.DELETED_DATE]: '10%',
  [TableCellId.STATUS]: '14%',
  [TableCellId.TASKS_COUNT]: '200px',
  [TableCellId.SLA]: '12%',
  [TableCellId.ACTIONS]: '90px',
};

export const tableCellMinWidthMap = {
  [TableCellId.CONDITION]: '220px',
  [TableCellId.CATEGORY]: '96px',
  [TableCellId.SUB_COMPANY_MESSAGE]: '140px',
  [TableCellId.PRIOR_TO]: '92px',
  [TableCellId.BROKER_STATUS]: '96px',
  [TableCellId.DELETED_DATE]: '104px',
  [TableCellId.STATUS]: '120px',
  [TableCellId.TASKS_COUNT]: '184px',
  [TableCellId.SLA]: '96px',
};

export const defaultOrder = {
  id: TableCellId.NUMBER,
  direction: SORT_DIRECTIONS.ASC,
};

export const UNKNOWN_PRIOR_TO_ORDER = 99;

export const OTHER_PRIOR_TO_TAB_VALUE = 'Other';

export const UNGROUPED_GROUP_KEY = 'ungrouped';
export const UNGROUPED_GROUP_LABEL = 'Other Tasks';

export const ConditionStatus = {
  PENDING: 'Pending',
  READY_TO_SIGN_OFF: 'Ready to Sign Off',
  SIGNED_OFF: 'Signed Off',
  REJECTED: 'Rejected',
  DELETED: 'Deleted',
};

export const OPEN_CONDITION_STATUSES = [
  ConditionStatus.PENDING,
  ConditionStatus.READY_TO_SIGN_OFF,
  ConditionStatus.REJECTED,
];

export const ConditionFilterKey = {
  PRIOR_TO: 'priorToTypeId',
  CATEGORY: 'conditionCategoryId',
};
